import React, {useEffect, useState} from 'react';

import Select from '../Select';

import './index.scss';
import TextField from '@mui/material/TextField';

const PhoneNumberInput = ({ name, onChange, list, value: defaultValue, reset, hasError }) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue])

  const handleChange = (e) => {
    onChange({ 'phone.countryCode': e });
  }
  const handleInput = (e) => {
    setValue(e.target.value);
    onChange({ 'phone.number': e.target.value });
  }

  return (
    <div className="phone-number-input">
      <Select reset={reset} list={list} selected={list[0]} flags="true" onChange={handleChange} />
      <TextField
        label={name}
        variant="outlined"
        value={value}
        error={hasError}
        onChange={handleInput} />
    </div>
  );
};

export default PhoneNumberInput;
